<template>
	<v-app class="fix-height primary">
		<template v-if="isAppReady">
			<nav-pane />
			<top-bar />
		</template>
			
		<v-content class="fix-height">
			<login-pane v-if="!isLoggedIn" />
			<splash-screen v-else-if="!isAppReady" />
			<router-view v-else />
		</v-content>

		<dialog-disclaimer @accept="acceptDisclaimer" @decline="declineDisclaimer" />
		<dialog-action-form/>
		<dialog-feedback-form />
	</v-app>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import TopBar from '@/components/TopBar.vue';
import SplashScreen from '@/components/SplashScreen.vue';
import NavPane from '@/components/NavPane.vue';
import LoginPane from '@/components/LoginPane.vue';
import DialogDisclaimer from '@/dialogs/DialogDisclaimer';
import DialogActionForm from '@/dialogs/DialogActionForm';
import DialogFeedbackForm from '@/dialogs/DialogFeedbackForm';

export default {
	components: { TopBar, NavPane, SplashScreen, LoginPane, DialogDisclaimer, DialogActionForm, DialogFeedbackForm },
	data() { return {
	}},
	computed: {
		...mapState(['isAppReady']),
		...mapGetters('auth', ['isLoggedIn','userID','disclaimerAccepted','disclaimerAcceptedAt']),
	},
	methods: {
		async acceptDisclaimer() {
			await this.$store.dispatch('users/acceptDisclaimer', this.userID);
			this.$store.dispatch('auth/hideDisclaimerDialog');
			this.$store.commit('auth/setDisclaimerAccepted');
		},
		declineDisclaimer() {
			this.$store.commit('auth/unsetDisclaimerAccepted');
			this.$store.dispatch('unloadAppData');
			this.$store.dispatch('auth/logout');
			window.location = process.env.VUE_APP_REDIRECT_OUT;
		},
	},
	watch: {
		async isLoggedIn(isLoggedIn) {
			// if the user is not logged-in yet, or has just been logged out
			if (!isLoggedIn) {
				this.$store.commit('auth/unsetDisclaimerAccepted');
				this.$store.dispatch('unloadAppData');
				return;
			}
			// if the user is logged-in, but the disclaimer has not been accepted yet
			if (!this.disclaimerAcceptedAt) {
				this.$store.dispatch('auth/showDisclaimerDialog');
				return;
			}

			// otherwise, the user is logged-in and has accepted the disclaimer
			this.$store.commit('auth/setDisclaimerAccepted');
		},
		disclaimerAccepted(isAccepted) {
			if (!isAccepted) { return }
			this.$store.dispatch('fetchAppData');
		},
	},
	created() {
		this.$store.dispatch('auth/autologin');
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			vm.$store.dispatch('handlePagination', to);
		});
	},
	beforeRouteUpdate(to, from, next) {
		this.$store.dispatch('handlePagination', to);
		this.$store.dispatch('search/search');
		next();
	},
}
</script>


<style lang="less">
	html, body, .fix-height {
		height: 100%;
		overflow: hidden;
	}

	// fix application wrapper's min height which is set to 100vh
	// this seems to be badly handled by Chrome and Safari
	#app .application--wrap {
		min-height: auto !important;
	}

	.scroll-y {
		-webkit-overflow-scrolling: touch;		
	}
	
	.user-text {
		text-align: justify;
		white-space: pre-wrap;
		word-break: break-word;
	}

	.compiled-md-text {
		ul, ol {
			margin-bottom: 16px;
		}
		
		pre code {
			display: block;
			padding: 8px;
			margin-bottom: 8px;

			&::before, &::after { display: none }
		}

		blockquote {
			margin-left: 0px;
			margin-bottom: 16px;
			padding: 8px;
			background-color: #eee;
			border-left: 4px solid #90CAF9;
			
			* { margin-bottom: 0 }
		}
	}
</style>